import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Menu, X } from "lucide-react";

const links = [
  { label: "For Agents", href: "#agents" },
  { label: "For Companies", href: "#companies" },
  { label: "How It Works", href: "#how" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#050914]/70 backdrop-blur-xl border-b border-[#1E293B]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="brand-logo"
          className="flex items-center gap-2.5 group"
        >
          <ShieldCheck className="w-6 h-6 text-[#D4AF37]" strokeWidth={2.2} />
          <span className="font-head font-black tracking-[0.18em] text-[#F8FAFC] text-lg leading-none">
            BODYGUARD<span className="text-[#D4AF37]"> EXP</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              data-testid={`nav-${l.href.slice(1)}`}
              className="font-body text-sm text-[#CBD5E1] hover:text-[#D4AF37] transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#waitlist")}
            data-testid="header-join-btn"
            className="font-head font-bold text-sm bg-[#D4AF37] text-[#050914] px-5 py-2.5 rounded-xl hover:bg-[#E4C569] transition-colors duration-200"
          >
            Join the Waitlist
          </button>
        </nav>

        <button
          className="md:hidden text-[#F8FAFC]"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="md:hidden bg-[#050914]/95 backdrop-blur-xl border-b border-[#1E293B] px-6 py-5 flex flex-col gap-4"
        >
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="font-body text-left text-[#CBD5E1] hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#waitlist")}
            className="font-head font-bold bg-[#D4AF37] text-[#050914] px-5 py-3 rounded-xl"
          >
            Join the Waitlist
          </button>
        </motion.div>
      )}
    </motion.header>
  );
};
